import type { Board } from "./board";
import { DistanceMap } from "./distanceMap";
import type { PassabilityRule } from "./passability";
import type { XY } from "./xy";

/** Per-turn cache: maps are shared within a turn and discarded when `board.turnCount` advances. */
export class DistanceMapCache {
	private cache: Map<string, DistanceMap> = new Map();
	private cachedTurnCount: number = -1;

	getDistanceMap(board: Board, target: XY, rule: PassabilityRule): DistanceMap {
		if (board.turnCount !== this.cachedTurnCount) {
			this.cache.clear();
			this.cachedTurnCount = board.turnCount;
		}

		const key = `${rule.key}:${target.x},${target.y}`;
		let map = this.cache.get(key);
		if (!map) {
			map = DistanceMap.buildFrom(board, target, (xy) => rule.isPassable(board, xy));
			this.cache.set(key, map);
		}
		return map;
	}
}
